import {
  ImprovementAreaAction,
  ImprovementAreaState,
} from 'store/data/improvementArea';
import { domainUtility } from 'utility';

const initialState: ImprovementAreaState = { allIds: [], byId: {} };

const improvementAreaReducer = (
  state: ImprovementAreaState = initialState,
  action: ImprovementAreaAction,
): ImprovementAreaState => {
  switch (action.type) {
    case 'data/improvementArea/ADD':
      return domainUtility.add(state, action.payload);
    case 'data/improvementArea/SET':
      return domainUtility.set(state, action.payload);
    case 'data/improvementArea/UPDATE':
      return domainUtility.update(state, action.payload);
    case 'data/improvementArea/REMOVE':
      return domainUtility.remove(state, action.payload);
    case 'data/improvementArea/SET_DOMAIN': {
      const { allIds, byId } = action.payload;
      return { allIds, byId };
    }
    default:
      return state;
  }
};

export default improvementAreaReducer;
